import { Delete } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import VNPortlet from '../VNPortlet/VNPortlet';

type Props = {
  name: string;
  label: string;
  required: boolean;
};

const VNDictionaryField = ({ name, label, required = false }: Props) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={{}} // start with empty object if none
      render={({ field: { value = {}, onChange } }) => {
        const safeValue = value ?? {};
        const entries = Object.entries(safeValue).map(([k, v]) => [k || '', v ?? '']);

        const handleAdd = () => {
          onChange({ ...value, '': '' });
        };

        const handleKeyChange = (oldKey: string, newKey: string) => {
          const newObj = { ...value };
          const val = newObj[oldKey];
          delete newObj[oldKey];
          newObj[newKey] = val;
          onChange(newObj);
        };

        const handleValueChange = (key: string, newVal: string) => {
          onChange({ ...value, [key]: newVal });
        };

        const handleRemove = (key: string) => {
          const newObj = { ...value };
          delete newObj[key];
          onChange(newObj);
        };

        return (
          <VNPortlet>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <h5>{label}</h5>
              <Button variant="contained" color="primary" size="small" onClick={handleAdd}>
                + Add
              </Button>
            </Box>
            <Divider />
            {entries.map(([k, v], idx) => (
              <Box key={idx} display="flex" gap={1} mt={1}>
                <TextField
                  value={k}
                  placeholder="Key"
                  size="small"
                  onChange={(e) => handleKeyChange(k, e.target.value)}
                  fullWidth
                />
                <TextField
                  value={v}
                  placeholder="Value"
                  size="small"
                  onChange={(e) => handleValueChange(k, e.target.value)}
                  fullWidth
                />
                <IconButton onClick={() => handleRemove(k)}>
                  <Delete />
                </IconButton>
              </Box>
            ))}
          </VNPortlet>
        );
      }}
    />
  );
};

export default VNDictionaryField;
